<script>
    import ConfiguracionCarrera from "./ConfiguracionCarrera/ConfiguracionCarrera.svelte";
    import ConfiguracionMateria from "./ConfiguracionMaterias/ConfiguracionMaterias.svelte";
    import { carrerasBasicas, materias } from "../MainStore.js";

    export let currentRoute;
    export let params;

    carrerasBasicas.actualizarDatos();
    materias.actualizarDatos();
</script>

<div>
    <ConfiguracionCarrera />
    <ConfiguracionMateria />
</div>